import React, { ComponentType, FC } from 'react';
import { FallbackProps, ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { QueryErrorResetBoundary } from '@tanstack/react-query';

type Props = {
  children: React.ReactNode;
  fallbackComponent: ComponentType<FallbackProps>;
  resetErrorBoundary?: (...args: any[]) => void;
};

const ErrorBoundary: FC<Props> = ({ children, resetErrorBoundary, fallbackComponent }) => {
  return (
    <QueryErrorResetBoundary>
      {(props) => (
        <ReactErrorBoundary onReset={props.reset} FallbackComponent={fallbackComponent}>
          {children}
        </ReactErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
};

export default ErrorBoundary;
